import * as dates from "date-arithmetic";
import moment from "moment";

export {
  milliseconds,
  seconds,
  minutes,
  hours,
  month,
  startOf,
  endOf,
  add,
  eq,
  gte,
  gt,
  lte,
  lt,
  inRange,
  min,
  max,
} from "date-arithmetic";

const MILLI = {
  seconds: 1000,
  minutes: 1000 * 60,
  hours: 1000 * 60 * 60,
  day: 1000 * 60 * 60 * 24,
};

const MONTHS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

export function monthsInYear(year) {
  let date = new Date(year, 0, 1);

  return MONTHS.map((i) => dates.month(date, i));
}

export function firstVisibleDay(date, localizer) {
  let firstOfMonth = dates.startOf(date, "month");

  return dates.startOf(firstOfMonth, "week", localizer.startOfWeek());
}

export function lastVisibleDay(date, localizer) {
  let endOfMonth = dates.endOf(date, "month");

  return dates.endOf(endOfMonth, "week", localizer.startOfWeek());
}

export function visibleDays(date, localizer) {
  let current = firstVisibleDay(date, localizer),
    last = lastVisibleDay(date, localizer),
    days = [];

  while (dates.lte(current, last, "day")) {
    days.push(current);
    current = dates.add(current, 1, "day");
  }

  return days;
}

export function ceil(date, unit) {
  let floor = dates.startOf(date, unit);

  return dates.eq(floor, date) ? floor : dates.add(floor, 1, unit);
}

export function range(start, end, unit = "day") {
  let current = start,
    days = [];

  while (dates.lte(current, end, unit)) {
    days.push(current);
    current = dates.add(current, 1, unit);
  }

  return days;
}

export function merge(date, time) {
  if (time == null && date == null) return null;

  if (time == null) time = new Date();
  if (date == null) date = new Date();

  date = dates.startOf(date, "day");
  date = dates.hours(date, dates.hours(time));
  date = dates.minutes(date, dates.minutes(time));
  date = dates.seconds(date, dates.seconds(time));
  return dates.milliseconds(date, dates.milliseconds(time));
}

export function eqTime(dateA, dateB) {
  return (
    dates.hours(dateA) === dates.hours(dateB) &&
    dates.minutes(dateA) === dates.minutes(dateB) &&
    dates.seconds(dateA) === dates.seconds(dateB)
  );
}

export function isJustDate(date) {
  return (
    dates.hours(date) === 0 &&
    dates.minutes(date) === 0 &&
    dates.seconds(date) === 0 &&
    dates.milliseconds(date) === 0
  );
}

export function duration(start, end, unit, firstOfWeek) {
  if (unit === "day") unit = "date";
  return Math.abs(
    dates[unit](start, undefined, firstOfWeek) -
      dates[unit](end, undefined, firstOfWeek),
  );
}

export function diff(dateA, dateB, unit) {
  if (!unit || unit === "milliseconds") return Math.abs(+dateA - +dateB);

  // the .round() handles an edge case
  // with DST where the total won't be exact
  // since one day in the range may be shorter/longer by an hour
  return Math.round(
    Math.abs(
      +dates.startOf(dateA, unit) / MILLI[unit] -
        +dates.startOf(dateB, unit) / MILLI[unit],
    ),
  );
}

export function total(date, unit) {
  let ms = date.getTime(),
    div = 1;

  switch (unit) {
    case "week":
      div *= 7;
    case "day":
      div *= 24;
    case "hours":
      div *= 60;
    case "minutes":
      div *= 60;
    case "seconds":
      div *= 1000;
  }

  return ms / div;
}

export function weekCount() {
  var d = new Date();
  d.setHours(0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  return Math.ceil(((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

export function today() {
  return dates.startOf(new Date(), "day");
}

export function yesterday() {
  return dates.add(dates.startOf(new Date(), "day"), -1, "day");
}

export function tomorrow() {
  return dates.add(dates.startOf(new Date(), "day"), 1, "day");
}

export function getWeekList() {
  let curr = moment().toDate();
  let list = [];

  for (let i = 1; i <= 7; i++) {
    let first = curr.getDate() - curr.getDay() + i;
    let day = new Date(curr.setDate(first));
    list.push(day);
  }

  return list;
}
export function getCurrentWeek() {
  var currentDate = moment();

  var weekStart = currentDate.clone().startOf("isoWeek");
  var weekEnd = currentDate.clone().endOf("isoWeek");

  var days = [];

  for (var i = 0; i <= 6; i++) {
    days.push(moment(weekStart).add(i, "days").format("YYYY-MM-DD"));
  }
  return days;
}

export function getWeekByDate(current) {
  var week = new Array();
  let list = [];
  current.setDate(current.getDate() - current.getDay() + 1);
  for (var i = 0; i < 7; i++) {
    week.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }
  week.map((ele) => list.push(moment(ele).format("YYYY-MM-DD")));

  return list;
}

export function getMonthDays(year, month) {
  var monthIndex = month - 1;
  var names = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  var date = new Date(year, monthIndex, 1);
  var result = [];
  while (date.getMonth() == monthIndex) {
    result.push({
      date: new Date(date),
      day: date.getDate(),
      dayName: names[date.getDay()],
    });
    date.setDate(date.getDate() + 1);
  }
  return result;
}

export function getDaysInMonth(month, year) {
  var date = new Date(year, month, 1);
  const startOfMonth = moment().startOf("01");
  var days = [];

  while (date.getMonth() === month) {
    days.push(moment(new Date(date)).format("YYYY-MM-DD"));
    date.setDate(date.getDate() + 1);
  }
  return days;
}

export function getYear() {
  const d = new Date();
  let year = d.getFullYear();
  return year;
}

export function getDiffInDays(d1, d2) {
  var date1 = moment(d1);
  var date2 = moment(d2);
  return date2.diff(date1, "days");
}

/**
 * Whole calendar days from local "today" to the expiry calendar date.
 * Positive = expiry is after today, zero = same calendar day, negative = before today.
 * Parses leading YYYY-MM-DD as that calendar date (avoids UTC-only string shifts).
 */
export function getCalendarDaysUntilExpiry(expiryDateRaw) {
  if (expiryDateRaw == null || expiryDateRaw === "") return null;

  const now = new Date();
  const startUtc = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

  let endUtc;
  if (typeof expiryDateRaw === "string") {
    const ymd = expiryDateRaw.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (ymd) {
      endUtc = Date.UTC(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]));
    }
  }

  if (endUtc === undefined) {
    const d = new Date(expiryDateRaw);
    if (Number.isNaN(d.getTime())) return null;
    endUtc = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  }

  return Math.round((endUtc - startUtc) / MILLI.day);
}

/**
 * Use API-provided expiry line unless it embeds a fractional day count (legacy / buggy payloads).
 */
export function shouldPreferServerExpiryCaption(msg) {
  return (
    typeof msg === "string" &&
    msg.trim() !== "" &&
    !(
      /(Expired|Expires in)\s*-?\d+\.\d+/i.test(msg) ||
      /-?\d+\.\d+\s+days\b/i.test(msg)
    )
  );
}

export function getDatesInRange(startDate, endDate) {
  const start = moment.utc(startDate);
  const end = moment.utc(endDate);

  const dates = [];

  let currentDate = start.clone();

  while (currentDate <= end) {
    dates.push(currentDate.format("YYYY-MM-DD"));

    currentDate.add(1, "days");
  }

  return dates;
}
export const getAllDaysInMonth = (month, year) => {
  let list = [];
  list = Array.from(
    { length: new Date(year, month, 0).getDate() },
    (_, i) => new Date(year, month - 1, i + 1),
  );
  let dates = list.map((date) => {
    return moment(date).format("DD");
  });

  list = dates;
  return list;
};

export const formatTime = (time) => {
  if (!time || time === null) return "";
  return moment(time, ["HH:mm"]).format("hh:mm a");
};

export const isBeforeTime = (startTime, endTime) => {
  return moment(startTime, "hh:mm A").isBefore(moment(endTime, "hh:mm A"));
};

export const isTimeBetween = function (startTime, endTime, serverTime) {
  let start = moment(startTime, "H:mm");
  let end = moment(endTime, "H:mm");
  let server = moment(serverTime, "H:mm");
  return server >= start && server <= moment("23:59:59", "h:mm:ss");
};

export const isTimeAfter = (tempCurrent, tempStart) => {
  // format  - 2022-01-03 14:01:00
  let isAfter = false;
  var current = new Date(tempCurrent);
  var start = new Date(tempStart);
  if (current.getTime() > start.getTime()) {
    isAfter = true;
  }
  return isAfter;
};

export const displayHours = (duration) => {
  let split = duration?.split(":");
  return `${parseFloat(split[0])}:${split[1] ?? 0}`;
};

export const displayHoursCount = (duration) => {
  let split = duration?.split(":");
  return `${parseFloat(split[0])}.${split[1] ?? 0}`;
};

export const getDayTime = () => {
  return moment().format(`YYYY-MM-DD HH:mm:ss`);
};

export const isFutureDate = (tempCurrent, tempStart) => {
  // 2024-07-08 12:00:00
  // 2024-07-09 12:00:00
  let isAfter = false;
  var current = new Date(tempCurrent);
  var start = new Date(tempStart);
  if (current.getTime() > start.getTime()) {
    isAfter = true;
  }
  return isAfter;
};

export const displayLeaveCount = (d1, d2, viewMonth) => {
  let count = 0;
  let startMonth = moment(d1, "YYYY-MM-DD").format("MM");
  let endMonth = moment(d2, "YYYY-MM-DD").format("MM");
  let monthToDisplay = viewMonth <= 9 ? `0${viewMonth}` : `${viewMonth}`;
  let dateList = getDatesInRange(d1, d2);

  if (monthToDisplay === startMonth) {
    count =
      dateList.filter(
        (ele) => moment(ele, "YYYY-MM-D").format("MM") === startMonth,
      ).length ?? 0;
  } else if (monthToDisplay === endMonth) {
    count =
      dateList.filter(
        (ele) => moment(ele, "YYYY-MM-D").format("MM") === endMonth,
      ).length ?? 0;
  }

  return count;
};

export const hasDiffEndMonth = (d1, d2) => {
  let startMonth = moment(d1).format(`MM`);
  let endMonth = moment(d2).format(`MM`);
  return !(startMonth == endMonth);
};

export const addDuration = (list) => {
  let result = "";
  let durationList = [];
  if (list.length > 0) {
    list.map((duration) => {
      durationList.push(moment.duration(duration));
    });
    result = list.reduce((accumulator, currentValue) => {
      const a = moment.duration(accumulator);
      const b = moment.duration(currentValue);
      return a.add(b);
    }, 0);
  }
  return `${result.hours()}:${result.minutes()}:${result.seconds()}`;
};

export const addDurationObject = (list) => {
  let result = "";
  let durationList = [];
  if (list.length > 0) {
    list.map((duration) => {
      durationList.push(moment.duration(duration));
    });
    result = list.reduce((accumulator, currentValue) => {
      const a = moment.duration(accumulator);
      const b = moment.duration(currentValue);
      return a.add(b);
    }, 0);
  }
  return result;
};

export const getDayToHours = (days) => {
  let hours = 24;
  return 24 * days;
};

export const getHoursDiff = (t1, t2) => {
  let date = moment().format("YYYY-MM-DD");
  let d1 = `${date} ${t1}`;
  let d2 = `${date} ${t2}`;
  return moment
    .utc(
      moment(d2, "YYYY-MM-DD HH:mm:ss").diff(moment(d1, "YYYY-MM-DD HH:mm:ss")),
    )
    .format("HH:mm");
};

export const hoursToDecimal = (value) => {
  var hoursMinutes = value.split(/[.:]/);
  var hours = parseInt(hoursMinutes[0], 10);
  var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
  return hours + minutes / 60;
};

export const decimalToHours = (decimal) => {
  var sign = decimal < 0 ? "-" : "";
  var min = Math.floor(Math.abs(decimal));
  var sec = Math.floor((Math.abs(decimal) * 60) % 60);
  return sign + (min < 10 ? "0" : "") + min + ":" + (sec < 10 ? "0" : "") + sec;
};

export const displaySheetHours = (range) => {
  return `${moment(range.from_date).format("LL")} - ${moment(
    range.to_date,
  ).format("LL")}`;
};

export const isValidDate = (date) => {
  let isValid = false;
  let dateString = moment(date);
  isValid = dateString.isValid();
  return isValid;
};

export const isValidTime = (time) => {
  // Thu Jul 24 2025 12:53:07 GMT+0530

  if (time === "") return true;
  let isValid = false;
  let timeString = moment(time, "HH:mm");
  isValid = timeString.isValid();
  return isValid;
};

/** Strict validation for "HH:mm" time strings (required fields). */
export const isValidHourMinute = (time) =>
  Boolean(
    time && String(time).trim() !== "" && moment(time, "HH:mm", true).isValid(),
  );

export function addTimes(time1, time2) {
  // Helper function to parse time strings and convert to seconds
  function timeToSeconds(time) {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  // Helper function to convert seconds to hh:mm:ss format
  function secondsToTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  // Convert both times to seconds
  const seconds1 = timeToSeconds(time1);
  const seconds2 = timeToSeconds(time2);

  // Add the seconds
  const totalSeconds = seconds1 + seconds2;

  // Convert back to hh:mm:ss format
  return secondsToTime(totalSeconds);
}

export const addTimeStrings = (time1, time2) => {
  const parseTime = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    return { hours, minutes };
  };

  const { hours: hours1, minutes: minutes1 } = parseTime(time1);
  const { hours: hours2, minutes: minutes2 } = parseTime(time2);

  // Calculate total hours and minutes
  let totalHours = hours1 + hours2;
  let totalMinutes = minutes1 + minutes2;

  // Normalize minutes and hours
  if (totalMinutes >= 60) {
    totalHours += Math.floor(totalMinutes / 60);
    totalMinutes = totalMinutes % 60;
  }

  // Format the result as HH:MM
  const formattedTime = `${String(totalHours).padStart(2, "0")}:${String(
    totalMinutes,
  ).padStart(2, "0")}`;
  return formattedTime;
};

export const getPayFrequency = (frequency) => {
  const today = moment();

  let fromDate;
  let toDate;

  switch (frequency) {
    case "Weekly":
      fromDate = today.isoWeekday(1).startOf("isoWeek"); // Start of the week (Monday)
      toDate = fromDate.clone().add(6, "days"); // End of the week (Sunday)
      break;

    case "2 Weekly":
      fromDate = today.isoWeekday(1).startOf("isoWeek").subtract(1, "week"); // Start of the previous week
      toDate = fromDate.clone().add(13, "days"); // End of the 2-week period (Sunday)
      break;

    case "Monthly":
      fromDate = today.startOf("month"); // Start of the month
      toDate = fromDate.clone().endOf("month"); // End of the month
      break;

    default:
      throw new Error("Invalid pay frequency");
  }

  return {
    from_date: fromDate.format("YYYY-MM-DD"),
    to_date: toDate.format("YYYY-MM-DD"),
  };
};

export const getNextPayPeriod = (frequency, currentFromDate, currentToDate) => {
  const fromDate = moment(currentFromDate);
  const toDate = moment(currentToDate);

  let newFromDate;
  let newToDate;

  switch (frequency) {
    case "Weekly":
      newFromDate = fromDate.clone().add(1, "week"); // For next week
      newToDate = newFromDate.clone().add(6, "days"); // End of next week
      break;

    case "2 Weekly":
      newFromDate = fromDate.clone().add(2, "weeks"); // For the next 2-week period
      newToDate = newFromDate.clone().add(13, "days"); // End of the next 2-week period
      break;

    case "Monthly":
      newFromDate = fromDate.clone().add(1, "month"); // For next month
      newToDate = newFromDate.clone().endOf("month"); // End of next month
      break;

    default:
      throw new Error("Invalid pay frequency");
  }

  return {
    from_date: newFromDate.format("YYYY-MM-DD"),
    to_date: newToDate.format("YYYY-MM-DD"),
  };
};

export const getPreviousPayPeriod = (
  frequency,
  currentFromDate,
  currentToDate,
) => {
  const fromDate = moment(currentFromDate);
  const toDate = moment(currentToDate);

  let newFromDate;
  let newToDate;

  switch (frequency) {
    case "Weekly":
      newFromDate = fromDate.clone().subtract(1, "week"); // For previous week
      newToDate = newFromDate.clone().add(6, "days"); // End of previous week
      break;

    case "2 Weekly":
      newFromDate = fromDate.clone().subtract(2, "weeks"); // For previous 2-week period
      newToDate = newFromDate.clone().add(13, "days"); // End of previous 2-week period
      break;

    case "Monthly":
      newFromDate = fromDate.clone().subtract(1, "month"); // For previous month
      newToDate = newFromDate.clone().endOf("month"); // End of previous month
      break;

    default:
      throw new Error("Invalid pay frequency");
  }

  return {
    from_date: newFromDate.format("YYYY-MM-DD"),
    to_date: newToDate.format("YYYY-MM-DD"),
  };
};

export function convertToMinutes(time) {
  const parts = time.split(":");
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parseInt(parts[2], 10);

  return hours * 60 + minutes + Math.round(seconds / 60);
}

export function formatUserTime(time = "00:00:00") {
  if (time) return moment(time, "HH:mm:ss").format("HH:mm");
  return null;
}

export function displayTotalHours(time) {
  let parts = time ? time.split(":") : "00:00:00";
  return `${parts[0]}:${parts[1]}`;
}

export function formatSaveTime(time) {
  if (time) return moment(time, "HH:mm").format("HH:mm:ss");
  return null;
}

export function IsInFuture(Date1, Date2) {
  // Convert the date strings into Date objects
  const date1 = new Date(Date1);
  const date2 = new Date(Date2);

  // Compare Date2 with Date1
  return date2 > date1;
}

export function isSameYear(Date1, DateToCheck) {
  // Using moment.js to parse the dates and compare the years
  return moment(Date1).year() === moment(DateToCheck).year();
}

export const hoursToDays = (hoursToConvert) => {
  let duration = moment.duration(hoursToConvert, "hours");
  let days = duration.asDays();
  return days;
};

export function getDatePeriod(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  if (d1.toDateString() === d2.toDateString()) {
    return "same";
  } else if (d1 < d2) {
    return "future";
  } else {
    return "past";
  }
}

export function getYearDifference(date1, date2) {
  const year1 = new Date(date1).getFullYear();
  const year2 = new Date(date2).getFullYear();

  return year2 - year1;
}

export function getLeaveStart(day, monthStr) {
  // Get the current year
  const currentYear = new Date().getFullYear();

  // Map month abbreviations to their numeric values (01 for January, 02 for February, etc.)
  const monthMap = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };

  // Get the month number (e.g., "07" for July)
  const month = monthMap[monthStr];

  if (!month) {
    throw new Error(`Invalid month abbreviation: ${monthStr}`);
  }

  // Format the date in the "YYYY-MM-DD" format
  return `${currentYear}-${month}-${day.toString().padStart(2, "0")}`;
}

function getMonthsBetweenDates(start_date, end_date) {
  const months = [];

  const start = moment(start_date, "YYYY-MM-DD");
  const end = moment(end_date, "YYYY-MM-DD");

  let current = start.clone();
  while (current.isBefore(end) || current.isSame(end, "month")) {
    months.push({
      month: current.format("MMM"),
      year: current.year(),
    });
    current.add(1, "month");
  }

  return months;
}

export const generatePeriod = (
  settingDate,
  settingMonth,
  year,
  isNav = false,
) => {
  let startDateMoment = moment()
    .year(year)
    .month(settingMonth)
    .date(settingDate);

  if (!isNav) {
    const today = moment();
    if (today.isBefore(startDateMoment)) {
      startDateMoment.subtract(1, "year");
    }
  }

  const startDate = startDateMoment.format("YYYY-MM-DD");
  const endDate = moment(startDateMoment)
    .add(1, "year")
    .subtract(1, "day")
    .format("YYYY-MM-DD");

  return {
    startDate,
    endDate,
    months: getMonthsBetweenDates(startDate, endDate),
  };
};

export const displayReadableDate = (date, hideYear = false) => {
  if (!date) return "~";
  return moment(date).format(hideYear ? "MMM DD" : "MMM DD, YYYY");
};

export const displayReadableDateTime = (date) => {
  if (!date) return "~";
  return moment(date).format("MMM DD, YYYY hh:mm A");
};

export const displayReadableTime = (time) => {
  if (!time) return "~";
  return moment(time, "HH:mm:ss").format("hh:mm A");
  // return moment(time, "HH:mm:ss").format("hh:mm A");
};
